import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, WidthType } from "docx"



export const top10list = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 350, before: 50, after: 500 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The table below shows how Mobile application compares with respect to the OWASP 2021 Top 10 list.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})


export function top10ListTable(mobileOWASP) {
    return new Table({
        width: { size: 80, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 1200 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 12, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "S/N",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "0189f9" },
                        indent: { left: 600 },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        width: { size: 60, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "VULNERABILITIES",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: {
                            type: ShadingType.SOLID,
                            color: "0189f9",
                        },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        width: { size: 28, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "STATUS",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: {
                            type: ShadingType.SOLID,
                            color: "0189f9",
                        },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "1",
                                        font: "Calibri",
                                        size: 22,
                                        color: 'ff0000',
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Improper Credential Usage",
                                        font: "Calibri",
                                        size: 22,
                                        color: '0f0f3f',
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: mobileOWASP.improperCredential === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: mobileOWASP.improperCredential === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "2",
                                        font: "Calibri",
                                        size: 22,
                                        color: 'ff0000',
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Inadequate Supply Chain Security ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '0f0f3f',
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: mobileOWASP.inadequateSupply === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: mobileOWASP.inadequateSupply === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "3",
                                        font: "Calibri",
                                        size: 22,
                                        color: 'ff0000',
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Insecure Authentication/Authorization ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '0f0f3f',
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: mobileOWASP.insecureAuthentication === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: mobileOWASP.insecureAuthentication === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "4",
                                        font: "Calibri",
                                        size: 22,
                                        color: 'ff0000',
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Insufficient Input/Output Validation",
                                        font: "Calibri",
                                        size: 22,
                                        color: '0f0f3f',
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: mobileOWASP.insufficientIO === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: mobileOWASP.insufficientIO === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "5",
                                        font: "Calibri",
                                        size: 22,
                                        color: 'ff0000',
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Insecure Communication ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '0f0f3f',
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: mobileOWASP.insecureComm === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: mobileOWASP.insecureComm === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "6",
                                        font: "Calibri",
                                        size: 22,
                                        color: 'ff0000',
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Inadequate Privacy Controls ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '0f0f3f',
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: mobileOWASP.inadequatePrivacy === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: mobileOWASP.inadequatePrivacy === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "7",
                                        font: "Calibri",
                                        size: 22,
                                        color: 'ff0000',
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Insufficient Binary Protections",
                                        font: "Calibri",
                                        size: 22,
                                        color: '0f0f3f',
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: mobileOWASP.insufficientBinary === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: mobileOWASP.insufficientBinary === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "8",
                                        font: "Calibri",
                                        size: 22,
                                        color: 'ff0000',
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Security Misconfiguration",
                                        font: "Calibri",
                                        size: 22,
                                        color: '0f0f3f',
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: mobileOWASP.securityMisConf === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: mobileOWASP.securityMisConf === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "9",
                                        font: "Calibri",
                                        size: 22,
                                        color: 'ff0000',
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Insecure Data Storage ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '0f0f3f',
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: mobileOWASP.insecureData === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: mobileOWASP.insecureData === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "10",
                                        font: "Calibri",
                                        size: 22,
                                        color: 'ff0000',
                                        bold: true,
                                        italics: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Insufficient Cryptography",
                                        font: "Calibri",
                                        size: 22,
                                        color: '0f0f3f',
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: mobileOWASP.insufficientCrypto === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: mobileOWASP.insufficientCrypto === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        },
                    }),
                ]
            }),
        ]
    })
}


function numberToWords(num) {
    const words = [
        "zero", "one", "two", "three", "four", "five",
        "six", "seven", "eight", "nine", "ten",
        "eleven", "twelve", "thirteen", "fourteen", "fifteen",
        "sixteen", "seventeen", "eighteen", "nineteen", "twenty",
        "twenty-one", "twenty-two", "twenty-three", "twenty-four", "twenty-five",
        "twenty-six", "twenty-seven", "twenty-eight", "twenty-nine", "thirty"
    ];

    if (num <= 30) return words[num];
    return num.toString();
}

export function observartionSummaryTextMobile(vulCount, applicationName) {
    const vulCountFormatted = `${numberToWords(vulCount)} (${vulCount})`;

    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        indent: { left: 600, right: 600 },
        spacing: { line: 350, before: 300, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `During the security testing exercise, ISECURION security testing team (hereafter referred as the ‘testing team’) identified ${vulCountFormatted} Vulnerabilities in the ${applicationName} Mobile Application. The vulnerabilities are categorized as per industry framework "Common Vulnerability Scoring System v3.1" i.e., CVSS3.1 scoring. The severity rating represented below is Base Score which represents only the intrinsic characteristics of a vulnerability that are constant over time and across user environments. To enable risk-focused mitigation, these vulnerabilities are summarized in five different categories (Critical, High, Medium, Low and Information).`,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
        ],
    })
}